import React from "react";
import headingImg from "../../assets/img/heading-img.png";
import bannerBg from "../../assets/img/bannr-img.jpg";
import { NavLink } from "react-router-dom";
import courseImg1 from "../../assets/img/course1.jpg";
import courseImg2 from "../../assets/img/course2.png";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CourseList = () => {
  return (
    <div>
      <section
        className="bannr-section"
        style={{
          backgroundImage: `url(${bannerBg})`,
        }}
      >
        <div className="container">
          <div className="bannr-text">
            <img src={headingImg} alt="icon" />
            <h2>Our Courses</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="breadcrumb-item" aria-current="page">
                Courses
              </li>
            </ol>
          </div>
        </div>
      </section>
      <section className="our-courses-section gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg1} alt="img" />
                  </figure>
                  <NavLink to="/course/1">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </NavLink>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg2} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg1} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg2} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg1} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6 mb-5">
              <div className="courses">
                <div className="courses-img">
                  <figure>
                    <img src={courseImg2} alt="img" />
                  </figure>
                  <a href="#">
                    <FontAwesomeIcon icon={faArrowRight} />
                  </a>
                </div>
                <div className="scholar">
                  <div>
                    <h4>Habib Al Noor</h4>
                    <span>Arabic scholar</span>
                  </div>
                </div>
                <div className="courses-text">
                  <a href="#">Quran Intermediate Course Brother</a>
                  <h4>$16.00</h4>
                  <span>Course Free</span>
                </div>
                <div className="courses-weeks">
                  <h6>10 weeks</h6>
                  <div className="border"></div>
                  <h6>50 enroll</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CourseList;
